"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWidthItems = exports.getWidthBehavior = exports.forEachSize = exports.addOverflowItemsToSizeMap = void 0;
/* eslint-disable import/prefer-default-export */
const getOrderedOverflow = mappedOverflow => Object.keys(mappedOverflow).sort((orderA, orderB) => Number(orderA) - Number(orderB)).map(sortedKey => mappedOverflow[sortedKey]);
const mergeOverflowMaps = ({
  sm = {},
  md = {},
  lg = {},
  xl = {},
  xxl = {}
}) => {
  const bigMap = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, sm), md), lg), xl), xxl);
  return getOrderedOverflow(bigMap);
};
const getWidthItems = (overflowMap, currentWidthName) => {
  const {
    sm,
    md,
    lg,
    xl,
    xxl
  } = overflowMap;
  switch (currentWidthName) {
    case 'sm':
      {
        return mergeOverflowMaps({
          sm,
          md,
          lg,
          xl,
          xxl
        });
      }
    case 'md':
      {
        return mergeOverflowMaps({
          md,
          lg,
          xl,
          xxl
        });
      }
    case 'lg':
      {
        return mergeOverflowMaps({
          lg,
          xl,
          xxl
        });
      }
    case 'xl':
      {
        return mergeOverflowMaps({
          xl,
          xxl
        });
      }
    case 'xxl':
      {
        return mergeOverflowMaps({
          xxl
        });
      }
    default:
      return [];
  }
};
// eslint-disable-next-line default-param-last
exports.getWidthItems = getWidthItems;
const getWidthBehavior = ({
  sm,
  md,
  lg,
  xl,
  xxl
} = {}, currentWidthName) => {
  let behavior;
  switch (currentWidthName) {
    case 'sm':
      {
        behavior = sm;
        if (behavior) break;
      }
    // eslint-disable-next-line no-fallthrough
    case 'md':
      {
        behavior = md;
        if (behavior) break;
      }
    // eslint-disable-next-line no-fallthrough
    case 'lg':
      {
        behavior = lg;
        if (behavior) break;
      }
    // eslint-disable-next-line no-fallthrough
    case 'xl':
      {
        behavior = xl;
        if (behavior) break;
      }
    // eslint-disable-next-line no-fallthrough
    case 'xxl':
      {
        // allow xxl to inherit xl if not defined - we introduced xxl after the breakpoints
        // prop was already established, this is to prevent
        // the breaking change of xxl being required
        behavior = xxl || xl;
        if (behavior) break;
      }
    // eslint-disable-next-line no-fallthrough
    default:
      break;
  }
  return behavior;
};
exports.getWidthBehavior = getWidthBehavior;
const SIZES = ['sm', 'md', 'lg', 'xl', 'xxl'];
const forEachSize = callback => SIZES.forEach(callback);
exports.forEachSize = forEachSize;
const addOverflowItemsToSizeMap = (aSizeMap, itemsOrder, items) => {
  if (!aSizeMap[itemsOrder]) {
    // eslint-disable-next-line no-param-reassign
    aSizeMap[itemsOrder] = [];
  }
  aSizeMap[itemsOrder].push(items);
};
exports.addOverflowItemsToSizeMap = addOverflowItemsToSizeMap;